<template>
  <el-form ref="form" :model="form" :rules="formRules" label-suffix=": ">
    <el-form-item label="请输入控制价" prop="controlPrice">
      <el-input-number
        v-model.trim="form.controlPrice"
        clearable
        :precision="2"
        controls-position="right"
        :min="0"
      />
      {{ offerUnit }}
      <money-in-cn v-if="offerUnit === '元'" :money="form.controlPrice" />
    </el-form-item>
    <el-form-item label="报价标红设置" prop="controlMethod">
      <el-radio-group v-model="form.controlMethod">
        <el-radio :label="controlMethodDict.LOWER.value">
          报价低于控制价，报价标红
        </el-radio>
        <el-radio :label="controlMethodDict.HIGHER.value">
          报价高于控制价，报价标红
        </el-radio>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>

<script>
import MoneyInCn from '@/components/common/MoneyInCn.vue'
import { requiredRule } from '@/utils/form-validate'
import { controlMethodDict } from '@/dictionary/hall/open-bid-hall'
import { submitKpbOpenControlPriceApi } from '@/api/hall/bid-open-hall'

export default {
  name: 'KpbOpenControlPriceForm',

  components: { MoneyInCn },

  props: {
    projectId: {
      type: [String, Number],
      default: ''
    },

    // 报价单位,根据项目的
    offerUnit: {
      type: String,
      default: ''
    },

    // 控制价信息
    controlPriceConfig: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      form: {
        // 控制价
        controlPrice: undefined,
        // 控制价大小
        controlMethod: undefined
      },
      formRules: {
        controlPrice: requiredRule('请填写控制价'),
        controlMethod: requiredRule('请选择控制价大小')
      },

      controlMethodDict
    }
  },

  watch: {
    controlPriceConfig: {
      handler(val) {
        if (val?.controlPrice) {
          this.form.controlPrice = val.controlPrice
          this.form.controlMethod = val.controlMethod
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    submitForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) return

          submitKpbOpenControlPriceApi(this.projectId, this.form)
            .then(res => {
              this.$message.success('控制价设置成功')
              resolve()
            })
            .catch(err => {
              if (err?.message) this.$message.error(err.message)
            })
        })
      })
    },

    resetForm() {
      this.$refs.form.resetFields()
      this.$refs.form.clearValidate()
    }
  }
}
</script>

<style scoped lang="scss"></style>
